import CityProcessIcon from './component'

export default CityProcessIcon
